import React from 'react';
import styles from './TableBox.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth } from '@/components/TableCell';
import moment from 'moment';

const TableBox = ({
    tableData: {
        dataList = [],
        pageNum,
        pageSize,
        resultTotal
    },
    onPageChange,
    tableOperate
}) => {

    const onOperateCell = (text, item) => {
        return <div className={styles.action}>
            <div className={styles.item} onClick={() => tableOperate('edit', item)}
            >编辑</div>
            {
                (item.state && item.state.code == '1') ?
                    <div className={styles.item} onClick={() => tableOperate('ban', item)}>禁用</div> :
                    <div className={styles.item} onClick={() => tableOperate('open', item)}>启用</div>
            }
            <div className={styles.item} onClick={() => tableOperate('remove', item)}
            >删除</div>
        </div>;
    };

    const columns = [
        {
            title: 'APP类型',
            dataIndex: 'appType',
            key: 'appType',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(text ? text.value : '')
        },
        {
            title: 'APP名称',
            dataIndex: 'appName',
            key: 'appName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '系统版本',
            dataIndex: 'systemType',
            key: 'systemType',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(text ? text.value : '')
        },
        {
            title: '版本号',
            dataIndex: 'version',
            key: 'version',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '最小支持版本号',
            dataIndex: 'minVersion',
            key: 'minVersion',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: 'APK下载地址',
            dataIndex: 'appUrl',
            key: 'appUrl',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '更新备注',
            dataIndex: 'updateDescription',
            key: 'updateDescription',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '更新类型',
            dataIndex: 'updateMode',
            key: 'updateMode',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: text => tooltip(text ? text.value : '')
        },
        {
            title: '修改人',
            dataIndex: 'modifyUserName',
            key: 'modifyUserName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '修改时间',
            dataIndex: 'gmtModified',
            key: 'gmtModified',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: text => text ? tooltip(moment(text).format('YYYY-MM-DD HH:mm:ss')) : ''
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: onOperateCell
        }
    ];

    return <div className={styles.tableContainer}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={record => record.id}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={onPageChange}
        />
    </div>;
};

TableBox.propTypes = {
    onPageChange: PropTypes.func,//分页变化
    tableData: PropTypes.object,//表格数据
    tableOperate: PropTypes.func,//表格操作
};

export default TableBox;